export const Footer = () => {
  return (
    <div className="bg-[#0B314E] h-fit flex flex-col justify-between items-center px-16 pt-10 pb-4">
      <div className="h-2/3  flex flex-col xl:flex-row w-full justify-between items-center">
        <img
          src="/tmm-light-logo.svg"
          alt="The Miles Market"
          className="h-2/3 w-auto mx-auto xl:mx-0"
        />

        <nav className="text-gray-400 text-center xl:text-left flex flex-col xl:flex-row gap-6 py-14 xl:py-0">
          <a
            href="https://www.themilesmarket.com/sell-airline-miles"
            className="hover:underline hover:cursor-pointer"
          >
            Sell Airline Miles
          </a>
          <a
            href="https://www.themilesmarket.com/buy-airline-miles"
            className="hover:underline hover:cursor-pointer"
          >
            Buy Airline Miles
          </a>
          <a
            href="https://www.themilesmarket.com/sell-hotel-points"
            className="hover:underline hover:cursor-pointer"
          >
            Sell Hotel Points
          </a>
          <a
            href="https://www.themilesmarket.com/sell-credit-card-points"
            className="hover:underline hover:cursor-pointer"
          >
            Sell Credit Card Points
          </a>
        </nav>
      </div>

      <p className="text-center text-white">
        All Right Reserved The Miles Market | &copy; {new Date().getFullYear()}
      </p>
    </div>
  );
};
